import React from "react";
import { Spinner, NonIdealState, Button } from "@blueprintjs/core";
import { IPanelProps, Panel } from "core/decorators/Panel";
import styled from "styled-components";
import labelProvider from "./Favorites.labels";
import FavoritesPanelConfig from "./FavoritesPanelConfig";
import ServiceRegistry from "core/util/ServiceRegistry";
import {
	FavoriteSearch,
	FavoriteSearchDelete
} from "./entities/FavoriteSearch";
import {
	FavoritePlaylist,
	FavoritePlaylistDelete
} from "./entities/FavoritePlaylist";
import Query from "core/api/QueryComponent";
import autobind from "autobind-decorator";
import Label from "core/components/label/Label";

import { IconNames } from "@blueprintjs/icons";
import PageLinkView from "common/views/pageLink/PageLink.view";
import UrlUtil from "core/util/UrlUtil";

const { Labels } = labelProvider;

interface IFavoritesPanelState {
	data: any;
}

const Table = styled.table`
	border: 1px solid;
	width: 100%;
`;

const TH = styled.th`
	text-align: left;
	padding: 10px;
`;

const TD = styled.td`
	text-align: left;
	padding: 10px;
	button {
		margin-right: 10px;
	}
`;

@Panel({
	id: "favorites",
	configClass: FavoritesPanelConfig,
	pageParams: true,
	labelProvider
})
class FavoritesPanel extends React.PureComponent<
	IPanelProps<FavoritesPanelConfig>,
	IFavoritesPanelState
> {
	public constructor(props: IPanelProps<FavoritesPanelConfig>) {
		super(props);
	}

	@autobind
	private renderSearchResults(data: FavoriteSearch[] = [], forceRefresh) {
		return (
			<Table>
				<caption>
					<Labels.MySavedSearchs />
				</caption>
				<thead>
					<tr>
						<TH>
							<Labels.SearchName />
						</TH>
						<TH>
							<Labels.ContentItems />
						</TH>
						<TH>
							<Labels.Actions />
						</TH>
					</tr>
				</thead>
				<tbody>
					{data.map(topic => (
						<tr>
							<TD>{topic.name}</TD>
							<TD>{topic.count}</TD>
							<TD>
								<Button
									small={true}
									onClick={() => this.onView(topic)}
									icon={IconNames.EYE_OPEN}
								/>

								<Button
									small={true}
									onClick={() =>
										this.onDelete(topic.id, forceRefresh)
									}
									icon={IconNames.TRASH}
								/>
							</TD>
						</tr>
					))}
				</tbody>
			</Table>
		);
	}

	@autobind
	private renderMyPlaylist(data: FavoritePlaylist[] = [], forceRefresh) {
		return (
			<Table>
				<caption>
					<Labels.MyPlaylist />
				</caption>
				<thead>
					<tr>
						<TH>
							<Labels.PlaylistTitle />
						</TH>
						<TH>
							<Labels.ContentType />
						</TH>
						<TH>
							<Labels.Actions />
						</TH>
					</tr>
				</thead>
				<tbody>
					{data.map(playlist => (
						<tr>
							<TD>{playlist.name}</TD>
							<TD>{playlist.contentType}</TD>
							<TD>
								<Button
									small={true}
									onClick={() => this.renderArticle(playlist)}
									icon={IconNames.EYE_OPEN}
								/>

								<Button
									small={true}
									onClick={() =>
										this.deletePlaylist(
											playlist.articleId,
											forceRefresh
										)
									}
									icon={IconNames.TRASH}
								/>
							</TD>
						</tr>
					))}
				</tbody>
			</Table>
		);
	}

	private renderArticle = playlist => {
		console.log(UrlUtil.getBasePath());
		location.href =
			window.location.origin + UrlUtil.getBasePath() + "article?articleId=" + playlist.articleId;
	};

	private deletePlaylist = (articleId: number, forceRefresh) => {
		const params = { articleId: articleId } as any;
		ServiceRegistry.getMutationService()
			.delete(params, FavoritePlaylistDelete)
			.then(res => {
				forceRefresh();
			})
			.catch(err => {});
	};

	private onView = topic => {
		location.href =
			window.location.origin + topic.query + "&searchid=" + topic.id;
	};

	private onDelete = (id: any, forceRefresh) => {
		const params = { id: id } as any;
		ServiceRegistry.getMutationService()
			.delete(params, FavoriteSearchDelete)
			.then(res => {
				forceRefresh();
			})
			.catch(err => {});
	};

	public render() {
		return [
			<Query.Many entity={FavoriteSearch} args={{}}>
				{({ data, loading, forceRefresh }) => {
					if (loading) {
						return <Spinner />;
					}
					if (!Array.isArray(data) || data.length === 0) {
						return (
							<NonIdealState
								title={
									<Label
										k="save.search.empty"
										v="No Saved Searchs"
									/>
								}
								description={
									<Label k="save.search.empty.desc" v="" />
								}
							/>
						);
					}

					return (
						<React.Fragment>
							{/*<Labels.MyFavorites />*/}
							{this.renderSearchResults(data, forceRefresh)}
						</React.Fragment>
					);
				}}
			</Query.Many>,
			<Query.Many entity={FavoritePlaylist} args={{}}>
				{({ data, loading, forceRefresh }) => {
					if (loading) {
						return <Spinner />;
					}
					if (!Array.isArray(data) || data.length === 0) {
						return (
							<NonIdealState
								title={
									<Label
										k="playlist.empty"
										v="No Playlist Created"
									/>
								}
								description={
									<Label k="save.search.empty.desc" v="" />
								}
							/>
						);
					}

					return (
						<React.Fragment>
							{this.renderMyPlaylist(data, forceRefresh)}
						</React.Fragment>
					);
				}}
			</Query.Many>
		];
	}
}



// WEBPACK FOOTER //
// ./src/panels/favorites/Favorites.panel.tsx